






































































































import Vue from 'vue'
import { ArcDataTab, DataTab } from '@/config/interfaces'
import ArcChart from '@/components/elements/accountBalanceDetails/ArcChart.vue'
import Utils from '@/helpers/Utils'

export default Vue.extend({
  name: 'AccountBalanceDetailsCard',

  components: { ArcChart },

  data: () => ({
    sheet: false
  }),

  methods: {
    toggleCard (): void {
      this.sheet = !this.sheet
    },
    createGraphData (dataTab: DataTab): Array<ArcDataTab> {
      return Utils.createGraphData(dataTab)
    }
  },

  computed: {
    cardHeight (): string {
      return this.$vuetify.breakpoint.mdAndUp ? '80vh' : '90vh'
    }
  },

  props: {
    activeTab: {
      type: Object as () => DataTab,
      required: true
    }
  }
})
